import React from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const SubmenuCrashReportsNavigation = () => {
	const { t } = useTranslation("admin");

	return (
		<div className="content-navigation">
			<Nav>
				<Nav.Item>
					<Nav.Link exact as={NavLink} to={`/admin/crash_reports`}>
						{t("modules.crash_report.header.title")}
					</Nav.Link>
				</Nav.Item>
				<Nav.Item>
					<Nav.Link exact as={NavLink} to={`/admin/crash_reports/occurrences`}>
						{t("modules.crash_report.field.occurrences.header.title")}
					</Nav.Link>
				</Nav.Item>
			</Nav>
		</div>
	);
};

export default SubmenuCrashReportsNavigation;
